<!--  -->
<template>
  <div class="container" v-if="isShowVideo">
    <div class="main-container">
      <img class="del-img" src="../../assets/images/btn_del.png" @click="cancel">
      <div class="video-box">
        <div class="video-wrapper">
          <video id="myVideo" :src="videoUrl" type="video/mp4" controls @ended="cancel()"></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Bus from '../../api/bus.js';
  import 'jquery';

  export default {
    name: '',
    data() {
      return {
        isShowVideo: false,
        videoUrl: ''
      }
    },

    props: [],

    watch: {},

    components: {},

    computed: {},

    created() {
      Bus.$on('isShowVideo', target => {
        this.isShowVideo = !this.isShowVideo;
        this.videoUrl = target.targetUrl;
        var inter = setInterval(() => {
          if (document.readyState == 'complete') {
            if ($('#myVideo')[0]) {
              $('#myVideo')[0].play();
            }
            clearInterval(inter)
          }
        }, 100)
      });
    },

    methods: {
      cancel() {
        this.isShowVideo = !this.isShowVideo;
      }
    }
  }

</script>
<style lang='scss' scoped>
  .container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;

    .main-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      top: 200px\0;
      left: 520px\0;

      img {
        position: absolute;
        top: -30px;
        right: -45px;
        left: 855px\0;
        width: 40px;
        height: 40px;
      }

      .video-box {
        width: 852px;
        height: 488px;
        background: #eee;
        display: flex;
        align-items: center;
        justify-content: center;

        .video-wrapper {
          width: 832px;
          height: 468px;

          video {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/videoBox/videoBox.vue